/**
 * 指定したIDの要素に埋め込まれたJSONを取得する
 *
 * @param {string} elementId - JSONを埋め込んだ要素のID
 * @returns {Record<string, any>} パースされたオブジェクト
 */
export function getJsonFromElement(elementId) {
    const el = document.getElementById(elementId)

    if (!el) {
        console.warn(`[json] element not found: #${elementId}`)
        return {}
    }

    try {
        return JSON.parse(el.textContent?.trim() || '{}')
    } catch (error) {
        console.error(`[json] parse failed: #${elementId}`, error)
        return {}
    }
}
